import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { NzAvatarModule } from 'ant-reset-private/avatar';
import { NzAddOnModule } from 'ant-reset-private/core';
import { NzEmptyModule } from 'ant-reset-private/empty';
import { NzGridModule } from 'ant-reset-private/grid';
import { NzSpinModule } from 'ant-reset-private/spin';

import { NzListItemMetaComponent } from './nz-list-item-meta.component';
import { NzListItemComponent } from './nz-list-item.component';
import { NzListComponent } from './nz-list.component';

@NgModule({
  imports: [CommonModule, NzSpinModule, NzGridModule, NzAvatarModule, NzAddOnModule, NzEmptyModule],
  declarations: [NzListComponent, NzListItemComponent, NzListItemMetaComponent],
  exports: [NzListComponent, NzListItemComponent, NzListItemMetaComponent]
})
export class NzListModule {}
